import { render, staticRenderFns } from "./list_staff_logs.vue?vue&type=template&id=78fbe187&scoped=true"
import script from "./list_staff_logs.vue?vue&type=script&lang=js"
export * from "./list_staff_logs.vue?vue&type=script&lang=js"
import style0 from "./list_staff_logs.vue?vue&type=style&index=0&id=78fbe187&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fbe187",
  null
  
)

export default component.exports